import { observer } from 'mobx-react';
import { useMemo } from 'react';
import { promobannerStore } from '../../store/promobannerStore';
import { PROMOBANNERR_TARGET } from '../../types/promobanners';
import { PRODUCT_TYPE } from 'src/types/product';
import {
  CATEGORY_MODAL_CATEGORY,
  CATEGORY_MODAL_PRODUCT,
  ICategoryOrProductItem,
} from 'src/view/containers/Modals/CategoryAndProductModal/CategoryAndProductModal';
// eslint-disable-next-line max-len
import CategoryAndProductModalOpen from 'src/view/containers/Modals/CategoryAndProductModal/components/CategoryAndProductModalOpen/CategoryAndProductModalOpen';
import Text from '~/view/components/Text/Text';
import './style.scss';

const PromobannerCategoryAndItem = observer(() => {
  const showProductInput: boolean = promobannerStore.promobanner.target === PROMOBANNERR_TARGET.ITEM;

  const categoryInputValid: boolean = useMemo(() => {
    return Boolean(
      (promobannerStore.promobanner.target === PROMOBANNERR_TARGET.CATEGORY && promobannerStore.isValid.target) ||
        (promobannerStore.promobanner.target === PROMOBANNERR_TARGET.ITEM && promobannerStore.promobanner.category)
    );
  }, [promobannerStore.promobanner, promobannerStore.isValid.target]);

  const productInputValid: boolean = useMemo(() => {
    return promobannerStore.promobanner.target === PROMOBANNERR_TARGET.ITEM && promobannerStore.isValid.target;
  }, [promobannerStore.promobanner.target, promobannerStore.isValid.target]);

  const selectCategoryAndProduct = (category?: ICategoryOrProductItem[], product?: ICategoryOrProductItem[]) => {
    promobannerStore.changePromobanner({ category: category ? category[0] : undefined, product: product ? product[0] : undefined }, true);
  };

  return (
    <div className="d-flex flex-column flex-grow-1">
      <div className="d-flex flex-row">
        <Text type="block-header" text="txt_category" className="w-100 promobanner-target-label" />
        {showProductInput ? <Text type="block-header" text="txt_item" className="ml-4 w-100" /> : null}
      </div>

      <CategoryAndProductModalOpen
        titleClassName="promobanner-target-category"
        selectedCategories={promobannerStore.promobanner.category ? [promobannerStore.promobanner.category] : undefined}
        selectedProducts={promobannerStore.promobanner.product ? [promobannerStore.promobanner.product] : undefined}
        isCategories={CATEGORY_MODAL_CATEGORY.SINGLE}
        isProducts={CATEGORY_MODAL_PRODUCT.SINGLE}
        productTypes={[PRODUCT_TYPE.PRODUCT, PRODUCT_TYPE.MEAL_COMBO, PRODUCT_TYPE.DEAL_COMBO]}
        categoryInputValid={categoryInputValid}
        productInputValid={productInputValid}
        save={selectCategoryAndProduct}
        className="mt-2 promobanner-target-item"
        productInput={showProductInput}
        showNames
      />
    </div>
  );
});

export default PromobannerCategoryAndItem;
